export class MapPermissions {
  exportImport: boolean = false;
  editDraw: boolean = false;
}
